import type { ReactNode } from "react";

type MarginaliaProps = {
  children: ReactNode;
  className?: string;
};

function joinClassNames(...values: Array<string | undefined>) {
  return values.filter(Boolean).join(" ");
}

export function Marginalia({ children, className }: MarginaliaProps) {
  return (
    <span
      className={joinClassNames(
        "hidden font-mono tracking-[0.04em] text-ink-soft lg:col-start-11 lg:col-span-2 lg:block lg:self-start lg:text-xs",
        className,
      )}
    >
      {children}
    </span>
  );
}
